import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/pass/in/rule/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/pass/in/rule/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/park/pass/in/rule/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/park/pass/in/rule/submit', params, options);

export const update = (params, options) =>
  request.post('/api/park/pass/in/rule/submit', params, options);
